"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classNames = require("classnames");
exports.defaultComponentMapping = {
    body: 'p',
    label: 'p',
    field: 'p',
    title: 'h1',
};
var Typography = function (_a) {
    var className = _a.className, _b = _a.color, color = _b === void 0 ? 'black' : _b, _c = _a.component, component = _c === void 0 ? 'body' : _c, children = _a.children;
    var elementName = exports.defaultComponentMapping[component];
    return React.createElement(elementName, {
        'data-color': color,
        className: classNames(styles.typography, styles[component], styles[color], className),
    }, children);
};
exports.default = Typography;
